import React, { FunctionComponent } from 'react';
import { ErrorWithHeader } from '@companion-professional/components';

export const Home: FunctionComponent = () => {
  return (
    <ErrorWithHeader 
      title="Access Required" 
      message="This page must be accessed via a checkup request." 
    />
  );
};
